import { routes } from './routes';

import { permissions } from './permissions';

export const permissionsRoutes: Record<string, string> = {
  [permissions.DASHBOARD.LIST]: routes.DASHBOARD,
  [permissions.RESALES.LIST]: routes.RESALES.LIST(),
  [permissions.USERS.LIST]: routes.USERS,
  [permissions.PERMISSIONS_GROUPS.LIST]: routes.PERMISSIONS_GROUPS,
  [permissions.ACTIONS.LIST]: routes.ACTIONS,
  [permissions.OFFERS.LIST]: routes.OFFERS.LIST,
  [permissions.OFFER_PURCHASES.LIST]: routes.OFFER_PURCHASES.LIST,
  [permissions.LEADS.LIST]: routes.LEADS.LIST(),
  [permissions.SUBSCRIBERS.LIST]: routes.SUBSCRIBERS.LIST(),
  [permissions.HELP.LIST]: routes.HELP.LIST,
  [permissions.OPERATING_AREAS.LIST]: routes.OPERATING_AREAS,
};
